<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Onboarding Slideshow -->
<app-onboarding-view></app-onboarding-view>

@if (layout === "empty") {
  <empty-layout></empty-layout>
}

<!-- Material -->
@if (layout === "material") {
  <material-layout></material-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
@if (layout === "classic") {
  <classic-layout></classic-layout>
}

<!-- Classy -->
@if (layout === "classy") {
  <classy-layout></classy-layout>
}

<!-- Compact -->
@if (layout === "compact") {
  <compact-layout></compact-layout>
}

<!-- Dense -->
@if (layout === "dense") {
  <dense-layout [navigation]="navigation"></dense-layout>
}

<!-- Futuristic -->
@if (layout === "futuristic") {
  <futuristic-layout></futuristic-layout>
}

<!-- Thin -->
@if (layout === "thin") {
  <thin-layout></thin-layout>
}

<!-- Ios installation modal -->
<ng-template #modalInstallIOS>
  <div class="absolute -left-4 top-10 grid grid-cols-5 gap-6 overflow-hidden">
    <div
      class="bg-slate-300 opacity-20 text-white font-bold rounded-xl p-5 h-15 w-15"
    ></div>
    <div
      class="bg-slate-300 opacity-30 text-white font-bold rounded-xl p-5 h-15 w-15"
    ></div>
    <div
      class="bg-slate-300 opacity-85 text-white p-2 font-bold rounded-xl h-15 w-15 flex items-center justify-center"
    >
      <img
        class="rounded-xl"
        src="images/logo/initial-32px.png"
        alt="AEM+ Logo"
      />
    </div>
    <div
      class="bg-slate-300 opacity-30 text-white font-bold rounded-xl p-5 h-15 w-15"
    ></div>
    <div
      class="bg-slate-300 opacity-20 text-white font-bold rounded-xl p-5 h-15 w-15"
    ></div>
  </div>
  <div class="flex flex-col w-full p-5">
    <div class="py-10"></div>
    <div class="text-white text-2xl font-bold py-3 text-center">
      Install AEM+
    </div>
    <div class="text-white text-medium font-normal pt-3 pb-7 text-center">
      Install this application on your home screen for quick and easy access
      when you're on the go.
    </div>
  </div>
  <div
    style="left: -0.01rem"
    class="absolute bottom-0 min-w-full text-md bg-white bg-opacity-10 text-center"
  >
    <p class="inline-flex justify-center items-center">
      Just tap
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        class="w-10 h-10 py-2 invert"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2z"
        />
      </svg>
      then 'Add to home screen'
    </p>
  </div>
</ng-template>

<ng-template #modalAllowNotification>
  <div class="absolute -left-4 top-10 grid grid-cols-5 gap-6 overflow-hidden">
    <div
      class="bg-white opacity-20 text-white font-bold rounded-xl p-5 h-15 w-15"
    ></div>
    <div
      class="bg-white opacity-30 text-white font-bold rounded-xl p-5 h-15 w-15"
    ></div>
    <div
      class="bg-white opacity-85 text-white p-2 font-bold rounded-xl h-15 w-15"
    >
      <img
        class="rounded-xl"
        src="images/logo/AEM-Plus-dark-24px.svg"
        alt="AEM+"
      />
    </div>
    <div
      class="bg-white opacity-30 text-white font-bold rounded-xl p-5 h-15 w-15"
    ></div>
    <div
      class="bg-white opacity-20 text-white font-bold rounded-xl p-5 h-15 w-15"
    ></div>
  </div>
  <div class="flex flex-col w-full p-5">
    <div class="py-10"></div>
    <div class="text-white text-2xl font-bold py-3 text-center">
      Stay in the Loop!
    </div>
    <div class="text-white text-medium font-normal pt-3 pb-7 text-center">
      "Get notified about your office table bookings and updates."
    </div>
  </div>
  <div
    style="left: -0.01rem"
    class="absolute bottom-0 min-w-full text-md bg-white bg-opacity-10 text-center"
  >
    <div class="grid grid-cols-2 gap-2 p-3">
      <button
        (click)="closeAllowNotificationModal()"
        class="text-md px-3 py-1.5 rounded-md bg-transparent hover:bg-black/10 transition-colors"
      >
        No, other time
      </button>
      <button
        (click)="onAllowNotificationPermission()"
        class="bg-indigo-500 text-white hover:bg-indigo-500/50 rounded-md text-md justify-center"
      >
        Get Notified
      </button>
    </div>
  </div>
</ng-template>
